export default "__VITE_ASSET__Rkg1I8rN__"